import { Component } from '@angular/core';
import { Auth } from 'aws-amplify';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticateService } from './shared/services/authenticate.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})

export class AppComponent {
  constructor(private authService: AuthenticateService, private route: ActivatedRoute,
    private router: Router) {
    this.authService.getS3Url();
  }
  async ngOnInit() {
    let checkSession = (await Auth.currentSession()).getAccessToken().getJwtToken()
    if(checkSession){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['/login']);
    }
  }
}
